export const employmentTypeOptions = [
	{ label: "Full-time", value: 501, short: "FT" },
	{ label: "Part-time", value: 502, short: "PT" },
	{ label: "External Contractor", value: 1843110, short: "CONTR" },
	{ label: "CIS Contractor", value: "cis-contractor", short: "CIS" },
	// { label: "Off Payroll Worker", value: "off-payroll-worker", short: "IR35" },
	{ label: "Director", value: "director", short: "DIR" },
	// { label: "Other", value: 503, short: "OTH" },
];
